import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'index',
      component: () => import(/* webpackChunkName: "index" */ '@/views/index/index.vue'),
      meta: {
        title: '不吐皮儿',
        needLogin: false
      }
    },
    {
      path: '/tao',
      name: 'tao',
      component: () => import(/* webpackChunkName: "tao" */ '@/views/tao/index.vue'),
      meta: {
        title: '淘酒',
        needLogin: false
      }
    },
    {
      path: '/cart',
      name: 'cart',
      component: () => import(/* webpackChunkName: "cart" */ '@/views/cart/index.vue'),
      meta: {
        title: '购物车',
        needLogin: true
      }
    },
    {
      path: '/my',
      name: 'my',
      component: () => import(/* webpackChunkName: "my" */ '@/views/my/index.vue'),
      meta: {
        title: '我的',
        needLogin: true
      }
    },
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "login" */ '@/views/login/index.vue'),
      meta: {
        title: '登录',
        needLogin: false
      }
    },
    {
      path: '/pay_hk',
      name: 'payHk',
      component: () => import(/* webpackChunkName: "pay" */ '@/views/pay/hk.vue'),
      meta: { title: '支付', needLogin: false }
    },
    {
      path: '/pay_wine_cellar',
      name: 'payWineCellar',
      component: () => import(/* webpackChunkName: "pay" */ '@/views/pay/wineCellar.vue'),
      meta: { title: '支付', needLogin: false }
    },
    {
      path: '/pay_succ',
      name: 'paySucc',
      component: () => import(/* webpackChunkName: "pay" */ '@/views/pay/succ.vue'),
      meta: { title: '支付成功', needLogin: false }
    },
    {
      path: '/pay_wx_succ',
      name: 'paySucc',
      component: () => import(/* webpackChunkName: "pay" */ '@/views/pay/wxSucc.vue'),
      meta: { title: '支付成功', needLogin: false }
    },
    {
      path: '/pay_fail',
      name: 'payFail',
      component: () => import(/* webpackChunkName: "pay" */ '@/views/pay/fail.vue'),
      meta: { title: '支付失败', needLogin: false }
    },
    {
      path: '/tips',
      name: 'tips',
      component: () => import(/* webpackChunkName: "tips" */ '@/views/tips/index.vue'),
      meta: { title: '购物须知', needLogin: false }
    },
    {
      path: '/about',
      name: 'about',
      component: () => import(/* webpackChunkName: "about" */ '@/views/about/index.vue'),
      meta: { title: '关于我们', needLogin: false }
    },
    {
      path: '/wine_cellar_detail',
      name: 'wineCellarDetail',
      component: () => import(/* webpackChunkName: "wineCellarDetail" */ '@/views/wineCellarDetail/index.vue'),
      meta: { title: '预约详情', needLogin: false }
    },
    {
      path: '/editUserInfo',
      name: 'editUserInfo',
      component: () => import(/* webpackChunkName: "editUserInfo" */ '@/views/editUserInfo/index.vue'),
      meta: { title: '用户信息', needLogin: true }
    },
    {
      path: '/productDetail',
      name: 'productDetail',
      component: () => import(/* webpackChunkName: "productDetail" */ '@/views/productDetail/index.vue'),
      meta: { title: '商品详情', needLogin: false }
    },
    {
      path: '/settlement',
      name: 'settlement',
      component: () => import(/* webpackChunkName: "settlement" */ '@/views/settlement/index.vue'),
      meta: { title: '确认订单', needLogin: true }
    },
    {
      path: '/address',
      name: 'address',
      component: () => import(/* webpackChunkName: "address" */ '@/views/address/index.vue'),
      meta: { title: '收货地址', needLogin: true }
    },
    {
      path: '/edit_address',
      name: 'edit_address',
      component: () => import(/* webpackChunkName: "edit_address" */ '@/views/edit_address/index.vue'),
      meta: { title: '编辑地址', needLogin: true }
    },
    {
      path: '/collect',
      name: 'collect',
      component: () => import(/* webpackChunkName: "collect" */ '@/views/collect/index.vue'),
      meta: { title: '我的心愿单', needLogin: true }
    },
    {
      path: '/wineCellar',
      name: 'wineCellar',
      component: () => import(/* webpackChunkName: "wineCellar" */ '@/views/wineCellar/index.vue'),
      meta: { title: '我的酒窖', needLogin: true }
    },
    {
      path: '/wineCellarApply',
      name: 'wineCellarApply',
      component: () => import(/* webpackChunkName: "wineCellarApply" */ '@/views/wineCellarApply/index.vue'),
      meta: { title: '申请预约', needLogin: true }
    },
    {
      path: '/wineCellarForm',
      name: 'wineCellarForm',
      component: () => import(/* webpackChunkName: "wineCellarForm" */ '@/views/wineCellarForm/index.vue'),
      meta: { title: '预约信息', needLogin: true }
    },
    {
      path: '/wineCellarCalendar',
      name: 'wineCellarCalendar',
      component: () => import(/* webpackChunkName: "wineCellarCalendar" */ '@/views/wineCellarCalendar/index.vue'),
      meta: { title: '选择日期', needLogin: true }
    },
    {
      path: '/wineCellarQr',
      name: 'wineCellarQr',
      component: () => import(/* webpackChunkName: "wineCellarQr" */ '@/views/wineCellarQr/index.vue'),
      meta: { title: '取货二维码', needLogin: true }
    },
    {
      path: '/evaluate',
      name: 'evaluate',
      component: () => import(/* webpackChunkName: "evaluate" */ '@/views/evaluate/index.vue'),
      meta: { title: '品鉴笔记', needLogin: true }
    },
    {
      path: '/comment',
      name: 'comment',
      component: () => import(/* webpackChunkName: "comment" */ '@/views/comment/index.vue'),
      meta: { title: '品鉴笔记', needLogin: true }
    },
    {
      path: '/commentDetail',
      name: 'commentDetail',
      component: () => import(/* webpackChunkName: "commentDetail" */ '@/views/commentDetail/index.vue'),
      meta: { title: '品鉴笔记', needLogin: true }
    },
    {
      path: '/order',
      name: 'order',
      component: () => import(/* webpackChunkName: "order" */ '@/views/order/index.vue'),
      meta: { title: '我的订单', needLogin: true }
    },
    {
      path: '/orderDetail',
      name: 'orderDetail',
      component: () => import(/* webpackChunkName: "orderDetail" */ '@/views/orderDetail/index.vue'),
      meta: { title: '订单详情', needLogin: true }
    },
    {
      path: '/articleList',
      name: 'articleList',
      component: () => import(/* webpackChunkName: "articleList" */ '@/views/articleList/index.vue'),
      meta: { title: '文章', needLogin: false }
    },
    {
      path: '/logistics',
      name: 'logistics',
      component: () => import(/* webpackChunkName: "logistics" */ '@/views/logistics/index.vue'),
      meta: { title: '物流详情', needLogin: true }
    },

    {
      path: '/search',
      name: 'search',
      component: () => import(/* webpackChunkName: "search" */ '@/views/search/index.vue'),
      meta: { title: '搜索', needLogin: false }
    },

    {
      path: '*',
      name: '404',
      component: () => import(/* webpackChunkName: "error" */ '@/views/error/404.vue'),
      meta: { title: '404', needLogin: false }
    }
  ]
})
